module.exports = __webpack_public_path__ + "img/red_heart_3d.9dbca86d.png";